import { USER_LOGIN, USER_LOGOUT, APP_IFRAMED, SET_MAX_SCORE } from "../actions";

import { loginUser, logoutUser } from "./user";
import { initialState as sweepstakesInitialState, setPrizeId, setLastSubmission, setSubmissionResult, resetSubmissionResult, setSubmissionStatus, resetSubmissionStatus} from "../instantwinform/reducers/sweepstakes";
import { SWEEPSTAKES_RESET_SUBMISSION_RESULT, SWEEPSTAKES_RESET_SUBMISSION_STATUS, SWEEPSTAKES_SET_PRIZE_ID, SWEEPSTAKES_SET_SUBMISSION_RESULT, SWEEPSTAKES_SET_SUBMISSION_STATUS, SWEEPSTATES_SET_LAST_SUBMISSION} from "../instantwinform/actions/sweepstakes";
import { isIframed } from "../utils/gsntv";
import { REWARD_VIDEO_READY, REWARD_VIDEO_IRONSOURCE, REWARD_VIDEO_OPEN, REWARD_VIDEO_COMPLETION, REWARD_VIDEO_AD_BLOCKED, REWARD_VIDEO_SUPPORT, REWARD_VIDEO_STALE, REWARD_VIDEO_INTENT_TO_OPEN } from "../actions/rewardVideo";
import { rewardVideoReady, setIronRV, rewardVideoOpen, rewardVideoComplete, rewardVideoAdBlocked, setRewardVideoSupport, updateRewardVideoStale, rewardVideoIntentToOpen } from "./rewardVideo";

const initialState = Object.assign({
  // userLoggedIn: true,
  userLoggedIn: false,
  user: null,
  isAppIframed: false,
  appInitiatedLogin: false,
  maxScore: null,
  rewardVideo: {
    adBlocked: false,
    // noCampaign: false,
    ready: null,
    open: false,
    // close: false,
    complete: false,
    ironRV: null,
    support: false,
    stale: true,
    intentToOpen: false
  }
}, sweepstakesInitialState);

function setAppIframed(state, action) {
  const isAppIframed = isIframed();

  return {
    ...state,
    isAppIframed
  };
}

function setMaxScore(state, action){
  console.log("Reducers :: setMaxScore - action = ", action);
  const maxScore = action.maxScore;
  return {
    ...state,
    maxScore
  }
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN:
      return loginUser(state, action);
    case USER_LOGOUT:
      return logoutUser(state, action);
    case APP_IFRAMED:
      return setAppIframed(state, action);
    case SET_MAX_SCORE:
      return setMaxScore(state, action);
    case REWARD_VIDEO_READY:
      return rewardVideoReady(state, action);
    case REWARD_VIDEO_IRONSOURCE:
      return setIronRV(state, action);
    case REWARD_VIDEO_OPEN:
      return rewardVideoOpen(state, action);
    case REWARD_VIDEO_COMPLETION:
      return rewardVideoComplete(state, action);
    case REWARD_VIDEO_AD_BLOCKED:
      return rewardVideoAdBlocked(state, action);
    case REWARD_VIDEO_SUPPORT:
      return setRewardVideoSupport(state, action);
    case REWARD_VIDEO_STALE:
      return updateRewardVideoStale(state, action);
    case REWARD_VIDEO_INTENT_TO_OPEN:
      return rewardVideoIntentToOpen(state, action);
    case SWEEPSTAKES_SET_PRIZE_ID:
      return setPrizeId(state, action);
    case SWEEPSTATES_SET_LAST_SUBMISSION:
      return setLastSubmission(state, action);
    case SWEEPSTAKES_SET_SUBMISSION_RESULT:
      return setSubmissionResult(state, action);
    case SWEEPSTAKES_RESET_SUBMISSION_RESULT:
      return resetSubmissionResult(state, action);
    case SWEEPSTAKES_SET_SUBMISSION_STATUS:
      return setSubmissionStatus(state, action);
    case SWEEPSTAKES_RESET_SUBMISSION_STATUS:
      return resetSubmissionStatus(state, action);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/js/reducers/index.js